// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"7decb177","455":"b740bebe"}[chunkId] + ".chunk.js";
};